/**
 * Advance widths (1/1000 em) of the report font, Archivo, as jsPDF reads them from the TTF files of the PDF
 * microservice (`asset/font/Archivo-*.ttf`, `doc.getStringUnitWidth`). Line wrapping decides the height of
 * every text cell, and a flat average width misplaces the break by a word often enough to add rows.
 *
 * Regenerate with the calibration tooling described in `inspection/__tests__/calibration/README.md`.
 */
const GLYPHS = " abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789ąćęłńóśźżĄĆĘŁŃÓŚŹŻäöüÄÖÜß.,:;-–—/()[]#%+=→·'\"!?_@&*<>|°";

const REGULAR_WIDTHS = [
  209, 545, 567, 519, 567, 548, 280, 556, 563, 225, 223, 514, 225, 860, 563, 570,
  567, 567, 332, 510, 297, 562, 504, 723, 513, 504, 498, 682, 698, 728, 734, 677,
  612, 796, 736, 267, 559, 662, 536, 847, 736, 788, 665, 788, 727, 673, 606, 731,
  648, 924, 680, 655, 635, 573, 521, 567, 573, 555, 571, 573, 553, 574, 573, 545,
  519, 548, 225, 563, 570, 510, 498, 498, 682, 728, 677, 536, 736, 788, 673, 635,
  635, 545, 570, 562, 682, 788, 731, 619, 277, 277, 296, 296, 333, 500, 1000, 294,
  355, 355, 296, 296, 582, 950, 625, 625, 1000, 333, 209, 374, 273, 578, 485, 1005,
  692, 407, 625, 625, 245, 400,
];

const BOLD_WIDTHS = [
  196, 580, 608, 573, 608, 584, 325, 607, 602, 267, 264, 570, 267, 891, 602, 613,
  608, 608, 380, 556, 342, 601, 547, 798, 572, 547, 519, 724, 722, 733, 739, 683,
  622, 802, 754, 301, 603, 725, 591, 872, 754, 793, 681, 793, 730, 679, 641, 748,
  694, 964, 706, 699, 653, 595, 596, 596, 596, 597, 595, 596, 596, 596, 595, 580,
  573, 584, 267, 602, 613, 556, 519, 519, 724, 733, 683, 591, 754, 793, 679, 653,
  653, 580, 613, 601, 724, 793, 748, 634, 307, 307, 335, 335, 333, 500, 1000, 300,
  364, 364, 350, 350, 600, 973, 641, 641, 1000, 333, 253, 456, 301, 613, 518, 1001,
  764, 407, 641, 641, 253, 400,
];

/** Width of a glyph missing from the table: the average advance of the lowercase Latin letters. */
export const FALLBACK_GLYPH_WIDTH = 496;

const toWidthMap = (widths: number[]): ReadonlyMap<string, number> =>
  new Map([...GLYPHS].map((glyph, index) => [glyph, widths[index] ?? FALLBACK_GLYPH_WIDTH]));

export const ARCHIVO_REGULAR_WIDTHS = toWidthMap(REGULAR_WIDTHS);
export const ARCHIVO_BOLD_WIDTHS = toWidthMap(BOLD_WIDTHS);
